import useRestoreTimer from "src/hooks/useRestoreTimer";

export default function useRestoreHotelTimer(session?: { startedAt: number; maxTime: number }) {
  useRestoreTimer(session);
}
